import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { prefetchFrequentlyUsedFolders } from 'owa-mail-frequently-used-folders';
export { default as loadFolderForest } from './actions/loadFolderForest';
export { default as selectDefaultFolder } from './actions/selectDefaultFolder';
export { default as loadPopoutDataToFolderStore } from './actions/loadPopoutDataToFolderStore';
export { default as loadPopoutDataToPublicFolderFavoriteStore, } from './actions/loadPopoutDataToPublicFolderFavoriteStore';
export { default as selectFolder } from './actions/selectFolder';
export { default as selectGroup } from './actions/selectGroup';
export { default as selectFavoriteSearch } from './actions/selectFavoriteSearch';
export { default as selectFavoriteCategory } from './actions/selectFavoriteCategory';
export { default as datapoints } from './actions/datapoints';
export { default as getCustomIcon } from './utils/getCustomIcon';
export { default as isGroupNodeSelected } from './utils/isGroupNodeSelected';
export { UpdateFavoriteOperationType, FolderForestNodeType, };
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "FolderForestActions", webpackPrefetch: true */ './lazyIndex');
});
export var lazyDeleteFolderInFolderForest = new LazyAction(lazyModule, function (m) { return m.deleteFolderInFolderForest; });
export var lazyToggleFavoriteFolder = new LazyAction(lazyModule, function (m) { return m.toggleFavoriteFolder; });
export var lazySelectPersona = new LazyAction(lazyModule, function (m) { return m.selectPersona; });
export var lazySelectPrivateDistributionList = new LazyAction(lazyModule, function (m) { return m.selectPrivateDistributionList; });
export var lazySelectFolderNode = new LazyAction(lazyModule, function (m) { return m.selectFolderNode; });
import './orchestrators/selectPreviousNodeOrchestrator';
export var lazySelectPreviousNodeInternal = new LazyImport(lazyModule, function (m) { return m.selectPreviousNodeInternal; });
runAfterInitialRender(function () {
    // prefetch frequently used folders
    prefetchFrequentlyUsedFolders();
});
//# sourceMappingURL=index.js.map